import Vue from 'vue';
import i18n from '@/i18n';
const vue = new Vue({i18n});

export const BIRTH = "BIRTH";
export const WEDDING = "WEDDING";
export const DEATH = "DEATH";
export const IDENTIFICATION = "IDENTIFICATION";
export const ADDRESS_PROOF = "ADDRESS_PROOF";
export const REFERENCE = "REFERENCE";
export const CNN = "CNN";

export const TYPE_OF_CERTIFICATES = [
    {id: BIRTH, name: vue.$t('enumerations.type-of-certificates.birth')},
    {id: WEDDING, name: vue.$t('enumerations.type-of-certificates.wedding')},
    {id: DEATH, name: vue.$t('enumerations.type-of-certificates.death')},
    {id: IDENTIFICATION, name: vue.$t('enumerations.type-of-certificates.identification')},
    {id: ADDRESS_PROOF, name: vue.$t('enumerations.type-of-certificates.address_proof')},
    {id: REFERENCE, name: vue.$t('enumerations.type-of-certificates.reference')},
    {id: CNN, name: vue.$t('enumerations.type-of-certificates.cnn')},
];
